/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.product.approvals.rpc.ApprovalsConfigurationRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
  useMutation,
  MutationHookOptions,
  MutationTuple,
} from 'data-fetching-client';
import * as References from './ApprovalsConfigurationRpc';
import * as Queries from './ApprovalsConfigurationRpc.dfc.new';
import type { AdditionalContextArgs } from './ApprovalsConfigurationRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type MutationTupleOverride<Response, Request, DataOverride> = OverrideData<
  MutationTuple<Response, Request>,
  DataOverride
>;
type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetApprovalConfigurationQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApprovalConfigurationResponseType>,
    References.GetApprovalConfigurationRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApprovalConfiguration',
            References.GetApprovalConfigurationResponseType
          >
        : References.GetApprovalConfigurationResponseType)
    | undefined;
};

export function useGetApprovalConfigurationQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApprovalConfigurationResponseType>,
    References.GetApprovalConfigurationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalConfigurationQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPROVAL_CONFIGURATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovalConfiguration: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovalConfigurationQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovalConfigurationQueryReturn<T>;
}

type UseGetApprovalConfigurationLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApprovalConfigurationResponseType>,
    References.GetApprovalConfigurationRequestType,
    T extends true
      ? Record<
          'getApprovalConfiguration',
          References.GetApprovalConfigurationResponseType
        >
      : References.GetApprovalConfigurationResponseType
  >;

export function useGetApprovalConfigurationLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApprovalConfigurationResponseType>,
    References.GetApprovalConfigurationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalConfigurationLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVAL_CONFIGURATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovalConfiguration: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApprovalConfigurationLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApprovalConfigurationLazyQueryReturn<T>;
}

type UseGetApprovalConfigurationSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetApprovalConfigurationResponseType>,
    References.GetApprovalConfigurationRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getApprovalConfiguration',
        References.GetApprovalConfigurationResponseType
      >
    : References.GetApprovalConfigurationResponseType;
};

export function useGetApprovalConfigurationSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApprovalConfigurationResponseType>,
    References.GetApprovalConfigurationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalConfigurationSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVAL_CONFIGURATION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApprovalConfiguration: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovalConfigurationSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovalConfigurationSuspenseQueryReturn<T>;
}

type UseGetApproversQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApproversResponseType>,
    References.GetApproversRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getApprovers', References.GetApproversResponseType>
        : References.GetApproversResponseType)
    | undefined;
};

export function useGetApproversQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApproversResponseType>,
    References.GetApproversRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApproversQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_APPROVERS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetApproversQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetApproversQueryReturn<T>;
}

type UseGetApproversLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApproversResponseType>,
    References.GetApproversRequestType,
    T extends true
      ? Record<'getApprovers', References.GetApproversResponseType>
      : References.GetApproversResponseType
  >;

export function useGetApproversLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApproversResponseType>,
    References.GetApproversRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApproversLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApproversLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApproversLazyQueryReturn<T>;
}

type UseGetApproversSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetApproversResponseType>,
    References.GetApproversRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getApprovers', References.GetApproversResponseType>
    : References.GetApproversResponseType;
};

export function useGetApproversSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApproversResponseType>,
    References.GetApproversRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApproversSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApprovers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApproversSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApproversSuspenseQueryReturn<T>;
}

type UsePutApprovalConfigurationMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.PutApprovalConfigurationResponseType>,
    References.PutApprovalConfigurationRequestType,
    T extends true
      ? Record<
          'putApprovalConfiguration',
          References.PutApprovalConfigurationResponseType
        >
      : References.PutApprovalConfigurationResponseType
  >;

export function usePutApprovalConfigurationMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.PutApprovalConfigurationResponseType>,
    References.PutApprovalConfigurationRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePutApprovalConfigurationMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PUT_APPROVAL_CONFIGURATION_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            putApprovalConfiguration: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePutApprovalConfigurationMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePutApprovalConfigurationMutationReturn<T>;
}

type UseSendRequestToEnableApprovalsMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.SendRequestToEnableApprovalsResponseType>,
    References.SendRequestToEnableApprovalsRequestType,
    T extends true
      ? Record<
          'sendRequestToEnableApprovals',
          References.SendRequestToEnableApprovalsResponseType
        >
      : References.SendRequestToEnableApprovalsResponseType
  >;

export function useSendRequestToEnableApprovalsMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.SendRequestToEnableApprovalsResponseType>,
    References.SendRequestToEnableApprovalsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseSendRequestToEnableApprovalsMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.SEND_REQUEST_TO_ENABLE_APPROVALS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            sendRequestToEnableApprovals: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseSendRequestToEnableApprovalsMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseSendRequestToEnableApprovalsMutationReturn<T>;
}

type UseListApproverCandidatesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListApproverCandidatesResponseType>,
    References.ListApproverCandidatesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listApproverCandidates',
            References.ListApproverCandidatesResponseType
          >
        : References.ListApproverCandidatesResponseType)
    | undefined;
};

export function useListApproverCandidatesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListApproverCandidatesResponseType>,
    References.ListApproverCandidatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApproverCandidatesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_APPROVER_CANDIDATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listApproverCandidates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListApproverCandidatesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListApproverCandidatesQueryReturn<T>;
}

type UseListApproverCandidatesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListApproverCandidatesResponseType>,
    References.ListApproverCandidatesRequestType,
    T extends true
      ? Record<
          'listApproverCandidates',
          References.ListApproverCandidatesResponseType
        >
      : References.ListApproverCandidatesResponseType
  >;

export function useListApproverCandidatesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListApproverCandidatesResponseType>,
    References.ListApproverCandidatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApproverCandidatesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_APPROVER_CANDIDATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listApproverCandidates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListApproverCandidatesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListApproverCandidatesLazyQueryReturn<T>;
}

type UseListApproverCandidatesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListApproverCandidatesResponseType>,
    References.ListApproverCandidatesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'listApproverCandidates',
        References.ListApproverCandidatesResponseType
      >
    : References.ListApproverCandidatesResponseType;
};

export function useListApproverCandidatesSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListApproverCandidatesResponseType>,
    References.ListApproverCandidatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListApproverCandidatesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_APPROVER_CANDIDATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listApproverCandidates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListApproverCandidatesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListApproverCandidatesSuspenseQueryReturn<T>;
}

type UseGetAvailableApproversQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAvailableApproversResponseType>,
    References.GetAvailableApproversRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAvailableApprovers',
            References.GetAvailableApproversResponseType
          >
        : References.GetAvailableApproversResponseType)
    | undefined;
};

export function useGetAvailableApproversQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAvailableApproversResponseType>,
    References.GetAvailableApproversRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAvailableApproversQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AVAILABLE_APPROVERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAvailableApprovers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAvailableApproversQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAvailableApproversQueryReturn<T>;
}

type UseGetAvailableApproversLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAvailableApproversResponseType>,
    References.GetAvailableApproversRequestType,
    T extends true
      ? Record<
          'getAvailableApprovers',
          References.GetAvailableApproversResponseType
        >
      : References.GetAvailableApproversResponseType
  >;

export function useGetAvailableApproversLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAvailableApproversResponseType>,
    References.GetAvailableApproversRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAvailableApproversLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AVAILABLE_APPROVERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAvailableApprovers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAvailableApproversLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAvailableApproversLazyQueryReturn<T>;
}

type UseGetAvailableApproversSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAvailableApproversResponseType>,
    References.GetAvailableApproversRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAvailableApprovers',
        References.GetAvailableApproversResponseType
      >
    : References.GetAvailableApproversResponseType;
};

export function useGetAvailableApproversSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAvailableApproversResponseType>,
    References.GetAvailableApproversRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAvailableApproversSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AVAILABLE_APPROVERS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAvailableApprovers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAvailableApproversSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAvailableApproversSuspenseQueryReturn<T>;
}

type UsePutAvailableApproversMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.PutAvailableApproversResponseType>,
    References.PutAvailableApproversRequestType,
    T extends true
      ? Record<
          'putAvailableApprovers',
          References.PutAvailableApproversResponseType
        >
      : References.PutAvailableApproversResponseType
  >;

export function usePutAvailableApproversMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.PutAvailableApproversResponseType>,
    References.PutAvailableApproversRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePutAvailableApproversMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PUT_AVAILABLE_APPROVERS_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            putAvailableApprovers: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePutAvailableApproversMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePutAvailableApproversMutationReturn<T>;
}

type UseGetAvailableApproversForActorTypeQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAvailableApproversForActorTypeResponseType>,
    References.GetAvailableApproversForActorTypeRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAvailableApproversForActorType',
            References.GetAvailableApproversForActorTypeResponseType
          >
        : References.GetAvailableApproversForActorTypeResponseType)
    | undefined;
};

export function useGetAvailableApproversForActorTypeQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetAvailableApproversForActorTypeResponseType>,
    References.GetAvailableApproversForActorTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAvailableApproversForActorTypeQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAvailableApproversForActorType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAvailableApproversForActorTypeQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAvailableApproversForActorTypeQueryReturn<T>;
}

type UseGetAvailableApproversForActorTypeLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAvailableApproversForActorTypeResponseType>,
    References.GetAvailableApproversForActorTypeRequestType,
    T extends true
      ? Record<
          'getAvailableApproversForActorType',
          References.GetAvailableApproversForActorTypeResponseType
        >
      : References.GetAvailableApproversForActorTypeResponseType
  >;

export function useGetAvailableApproversForActorTypeLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAvailableApproversForActorTypeResponseType>,
    References.GetAvailableApproversForActorTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAvailableApproversForActorTypeLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAvailableApproversForActorType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAvailableApproversForActorTypeLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAvailableApproversForActorTypeLazyQueryReturn<T>;
}

type UseGetAvailableApproversForActorTypeSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAvailableApproversForActorTypeResponseType>,
    References.GetAvailableApproversForActorTypeRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAvailableApproversForActorType',
        References.GetAvailableApproversForActorTypeResponseType
      >
    : References.GetAvailableApproversForActorTypeResponseType;
};

export function useGetAvailableApproversForActorTypeSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAvailableApproversForActorTypeResponseType>,
    References.GetAvailableApproversForActorTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAvailableApproversForActorTypeSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAvailableApproversForActorType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAvailableApproversForActorTypeSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAvailableApproversForActorTypeSuspenseQueryReturn<T>;
}

type UsePutAvailableApproversForActorTypeMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.PutAvailableApproversForActorTypeResponseType>,
    References.PutAvailableApproversForActorTypeRequestType,
    T extends true
      ? Record<
          'putAvailableApproversForActorType',
          References.PutAvailableApproversForActorTypeResponseType
        >
      : References.PutAvailableApproversForActorTypeResponseType
  >;

export function usePutAvailableApproversForActorTypeMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.PutAvailableApproversForActorTypeResponseType>,
    References.PutAvailableApproversForActorTypeRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePutAvailableApproversForActorTypeMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PUT_AVAILABLE_APPROVERS_FOR_ACTOR_TYPE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            putAvailableApproversForActorType: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePutAvailableApproversForActorTypeMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePutAvailableApproversForActorTypeMutationReturn<T>;
}

type UsePutApprovalTemplateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.PutApprovalTemplateResponseType>,
    References.PutApprovalTemplateRequestType,
    T extends true
      ? Record<
          'putApprovalTemplate',
          References.PutApprovalTemplateResponseType
        >
      : References.PutApprovalTemplateResponseType
  >;

export function usePutApprovalTemplateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.PutApprovalTemplateResponseType>,
    References.PutApprovalTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePutApprovalTemplateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PUT_APPROVAL_TEMPLATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            putApprovalTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePutApprovalTemplateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePutApprovalTemplateMutationReturn<T>;
}

type UseDeleteApprovalTemplateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DeleteApprovalTemplateResponseType>,
    References.DeleteApprovalTemplateRequestType,
    T extends true
      ? Record<
          'deleteApprovalTemplate',
          References.DeleteApprovalTemplateResponseType
        >
      : References.DeleteApprovalTemplateResponseType
  >;

export function useDeleteApprovalTemplateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteApprovalTemplateResponseType>,
    References.DeleteApprovalTemplateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteApprovalTemplateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_APPROVAL_TEMPLATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteApprovalTemplate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteApprovalTemplateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteApprovalTemplateMutationReturn<T>;
}

type UseGetApprovalDelegatesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApprovalDelegatesResponseType>,
    References.GetApprovalDelegatesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApprovalDelegates',
            References.GetApprovalDelegatesResponseType
          >
        : References.GetApprovalDelegatesResponseType)
    | undefined;
};

export function useGetApprovalDelegatesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApprovalDelegatesResponseType>,
    References.GetApprovalDelegatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalDelegatesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPROVAL_DELEGATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovalDelegates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovalDelegatesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovalDelegatesQueryReturn<T>;
}

type UseGetApprovalDelegatesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApprovalDelegatesResponseType>,
    References.GetApprovalDelegatesRequestType,
    T extends true
      ? Record<
          'getApprovalDelegates',
          References.GetApprovalDelegatesResponseType
        >
      : References.GetApprovalDelegatesResponseType
  >;

export function useGetApprovalDelegatesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApprovalDelegatesResponseType>,
    References.GetApprovalDelegatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalDelegatesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVAL_DELEGATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovalDelegates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApprovalDelegatesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApprovalDelegatesLazyQueryReturn<T>;
}

type UseGetApprovalDelegatesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetApprovalDelegatesResponseType>,
    References.GetApprovalDelegatesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getApprovalDelegates',
        References.GetApprovalDelegatesResponseType
      >
    : References.GetApprovalDelegatesResponseType;
};

export function useGetApprovalDelegatesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApprovalDelegatesResponseType>,
    References.GetApprovalDelegatesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalDelegatesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVAL_DELEGATES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApprovalDelegates: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovalDelegatesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovalDelegatesSuspenseQueryReturn<T>;
}

type UsePutApprovalDelegateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.PutApprovalDelegateResponseType>,
    References.PutApprovalDelegateRequestType,
    T extends true
      ? Record<
          'putApprovalDelegate',
          References.PutApprovalDelegateResponseType
        >
      : References.PutApprovalDelegateResponseType
  >;

export function usePutApprovalDelegateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.PutApprovalDelegateResponseType>,
    References.PutApprovalDelegateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePutApprovalDelegateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PUT_APPROVAL_DELEGATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            putApprovalDelegate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePutApprovalDelegateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePutApprovalDelegateMutationReturn<T>;
}

type UseDeleteApprovalDelegateMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.DeleteApprovalDelegateResponseType>,
    References.DeleteApprovalDelegateRequestType,
    T extends true
      ? Record<
          'deleteApprovalDelegate',
          References.DeleteApprovalDelegateResponseType
        >
      : References.DeleteApprovalDelegateResponseType
  >;

export function useDeleteApprovalDelegateMutation<T extends boolean = false>(
  options?: MutationHookOptions<
    Record<'result', References.DeleteApprovalDelegateResponseType>,
    References.DeleteApprovalDelegateRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseDeleteApprovalDelegateMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.DELETE_APPROVAL_DELEGATE_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            deleteApprovalDelegate: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseDeleteApprovalDelegateMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseDeleteApprovalDelegateMutationReturn<T>;
}

type UseGetApprovalDelegationOptionQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApprovalDelegationOptionResponseType>,
    References.GetApprovalDelegationOptionRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApprovalDelegationOption',
            References.GetApprovalDelegationOptionResponseType
          >
        : References.GetApprovalDelegationOptionResponseType)
    | undefined;
};

export function useGetApprovalDelegationOptionQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApprovalDelegationOptionResponseType>,
    References.GetApprovalDelegationOptionRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalDelegationOptionQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPROVAL_DELEGATION_OPTION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovalDelegationOption: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovalDelegationOptionQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovalDelegationOptionQueryReturn<T>;
}

type UseGetApprovalDelegationOptionLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApprovalDelegationOptionResponseType>,
    References.GetApprovalDelegationOptionRequestType,
    T extends true
      ? Record<
          'getApprovalDelegationOption',
          References.GetApprovalDelegationOptionResponseType
        >
      : References.GetApprovalDelegationOptionResponseType
  >;

export function useGetApprovalDelegationOptionLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApprovalDelegationOptionResponseType>,
    References.GetApprovalDelegationOptionRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalDelegationOptionLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPROVAL_DELEGATION_OPTION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApprovalDelegationOption: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApprovalDelegationOptionLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApprovalDelegationOptionLazyQueryReturn<T>;
}

type UseGetApprovalDelegationOptionSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetApprovalDelegationOptionResponseType>,
      References.GetApprovalDelegationOptionRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getApprovalDelegationOption',
          References.GetApprovalDelegationOptionResponseType
        >
      : References.GetApprovalDelegationOptionResponseType;
  };

export function useGetApprovalDelegationOptionSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApprovalDelegationOptionResponseType>,
    References.GetApprovalDelegationOptionRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApprovalDelegationOptionSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPROVAL_DELEGATION_OPTION_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApprovalDelegationOption: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApprovalDelegationOptionSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApprovalDelegationOptionSuspenseQueryReturn<T>;
}

type UsePutApprovalDelegationOptionMutationReturn<T extends boolean> =
  MutationTupleOverride<
    Record<'result', References.PutApprovalDelegationOptionResponseType>,
    References.PutApprovalDelegationOptionRequestType,
    T extends true
      ? Record<
          'putApprovalDelegationOption',
          References.PutApprovalDelegationOptionResponseType
        >
      : References.PutApprovalDelegationOptionResponseType
  >;

export function usePutApprovalDelegationOptionMutation<
  T extends boolean = false,
>(
  options?: MutationHookOptions<
    Record<'result', References.PutApprovalDelegationOptionResponseType>,
    References.PutApprovalDelegationOptionRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UsePutApprovalDelegationOptionMutationReturn<T> {
  const [getter, { data, ...rest }] = useMutation(
    Queries.PUT_APPROVAL_DELEGATION_OPTION_MUTATION,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            putApprovalDelegationOption: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UsePutApprovalDelegationOptionMutationReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UsePutApprovalDelegationOptionMutationReturn<T>;
}
